const translation = {
  title: 'Kiểm tra truy vấn',
  desc: 'Kiểm tra hiệu quả truy xuất của Kiến thức dựa trên văn bản truy vấn đã cho.',
  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
  recents: 'Gần đây',
  table: {
    header: {
      source: 'Nguồn',
      text: 'Văn bản',
      time: 'Thời gian',
    },
  },
  input: {
    title: 'Văn bản nguồn',
    placeholder: 'Vui lòng nhập một văn bản, khuyến nghị sử dụng một câu khẳng định ngắn.',
    countWarning: 'Tối đa 200 ký tự.',
    indexWarning: 'Chỉ có sẵn trong Kiến thức chất lượng cao.',
    testing: 'Đang kiểm tra',
  },
  hit: {
    title: 'CÁC ĐOẠN VĂN ĐƯỢC TRUY XUẤT',
    emptyTip: 'Kết quả kiểm tra truy vấn sẽ hiển thị ở đây',
  },
  noRecentTip: 'Không có kết quả truy vấn gần đây',
  viewChart: 'Xem BIỂU ĐỒ VECTOR',
  settingTitle: 'Cài đặt truy xuất',
  viewDetail: 'Xem chi tiết',
  records: 'Hồ sơ',
  open: 'Mở',
  keyword: 'Từ khoá',
  hitChunks: 'Nhấn {{num}} đoạn con',
  chunkDetail: 'Chi tiết khối',
}

export default translation
